import get from 'lodash.get';
import services from '@/services/index';

export default function alertsServiceFactory(services) {
  const thisService = {
    initAsync,
    initJoinRequestsAsync,
  };

  return thisService;

  //////////////

  function initAsync() {
    let promises = [];
    promises.push(initJoinRequestsAsync());
    return Promise.resolve(promises).then(() => {

    })
      .catch(() => {
        console.warn('PrintOS Header: Alerts service failed to initialize');
        return Promise.resolve();
      });
  }

  function initJoinRequestsAsync() {
    if (!services.session.isUser()) {
      return Promise.resolve();
    }

    return services.http.get('sso_request', 'request/addusers').then(resp => {
      let openRequests = get(resp, 'data.requestList', []);
      for (let i = 0; i < openRequests.length; i++) {
        openRequests[i].orgName = resp.data.organizationNames[i];
      }

      services.session.sendClientEvent('posh-join-requests-updated', openRequests);
      let trackedRequests = services.preferences.getPreference('RequestsToTrack', 'onboarding');
      if (!trackedRequests) {
        trackedRequests = [];
      }

      let updated = false;
      openRequests.forEach(or => {
        let found = trackedRequests.find(tr => { return tr.id === or.id });
        if (!found) {
          updated = true;
          trackedRequests.push({
            id: or.id,
            name: or.orgName,
            orgId: or.organizationId,
          });
        }
        else {
          if (!found.orgId) {
            updated = true;
            found.orgId = or.organizationId;
          }
        }
      });

      let resolvedRequests = [];
      trackedRequests.forEach(tr => {
        let found = openRequests.find(or => { return or.id === tr.id });
        if (!found) {
          resolvedRequests.push(tr);
        }
      });

      if (resolvedRequests.length > 0) {
        updated = true;
        trackedRequests = trackedRequests.filter(tr => {
          return !resolvedRequests.find(rr => { return tr.id === rr.id });
        });
      }

      if (trackedRequests.length > 0) {
        // If we still have outstanding requests, we'll check every 5 minutes;
        setTimeout(initJoinRequestsAsync, .5 * 60 * 1000);
      }

      if (updated) {
        let promises = [];
        promises.push(services.preferences.setPreferenceAsync('RequestsToTrack', trackedRequests, 'onboarding'));
        promises.push(processResolvedRequestsAsync(resolvedRequests));
        return Promise.all(promises);
      }
    })
      .catch(e => {
        console.log('PrintOS Header alerts - Failed to process');
        return Promise.resolve();
      });
  }

  function processResolvedRequestsAsync(requests) {
    return services.session.getContextsAsync(true).then(resp => {
      requests.forEach(r => {
        let context = resp.find(c => { return c.id === r.orgId });
        if (context) {
          // Request accepted
          services.ui.addInlineAlert({
            id: `printos-join-org-accepted-${r.orgId}`,
            severity: 'ok',
            title: services.i18n.$t('header.inlineAlerts.JoinOrgRequestAccepted'),
            description: services.i18n.$t('header.inlineAlerts.JoinOrgRequestAcceptedDescription', [r.name]),
            cooldown: 0,
            actions: [
              {
                type: 'link',
                title: services.i18n.$t('header.inlineAlerts.JoinOrgRequestSwitch'),
                callback: () => {
                  services.ga.eventTrack('printos', 'Inline Alert Action Clicked', 'printos-join-org-accepted');
                  services.session.setContextAsync(r.orgId, true);
                },
              }
            ],
          });
        }
        else {
          // Request denied
          services.ui.addInlineAlert({
            id: `printos-join-org-denied-${r.orgId}`,
            severity: 'warn',
            title: services.i18n.$t('header.inlineAlerts.JoinOrgRequestDenied'),
            description: services.i18n.$t('header.inlineAlerts.JoinOrgRequestDeniedDescription', [r.name]),
            cooldown: 0,
            actions: [],
          });
        }
      })
    });
  }
}
